module.exports = __webpack_public_path__ + "static/media/IMG_20190130_112725964.749658ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_20190130_112725964.jpg
// module id = 45
// module chunks = 0